import React from 'react';
import { useRouter } from 'next/navigation';
import { ShieldX } from 'lucide-react';

interface AccessRestrictedProps {
  title?: string;
  message?: string;
  buttonText?: string;
  onGoBack?: () => void;
  className?: string;
}

export function AccessRestricted({
  title = "Access Restricted",
  message = "You don't have permission to access this resource. Please contact your administrator if you believe this is an error.",
  buttonText = "Go Back",
  onGoBack,
  className = ""
}: AccessRestrictedProps) {
  const router = useRouter();

  const handleGoBack = () => {
    if (onGoBack) {
      onGoBack();
    } else {
      router.back();
    }
  };

  return (
    <div className={`flex flex-col items-center justify-center py-12 ${className}`}>
      <div className="flex flex-col items-center gap-6 p-12 text-center max-w-md mx-auto">
        {/* Icon Container */}
        <div className="flex items-center justify-center w-20 h-20 bg-red-50 rounded-full border-2 border-red-100">
          <ShieldX className="w-10 h-10 text-red-500" />
        </div>
        
        {/* Content Container */}
        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-gray-900 leading-tight">
            {title}
          </h3>
          <p className="text-gray-600 text-base leading-relaxed max-w-sm">
            {message}
          </p>
        </div>
        
        {/* Action Button */}
        <div className="pt-2">
          <button
            onClick={handleGoBack}
            className="btn btn-primary"
            style={{
              width: 'auto',
              minWidth: '140px',
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AccessRestricted;
